import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { buildContextualToolboxComponentsMap } from "../blocks/componentMaps";
import { PageSkeleton } from "../components/PageSkeleton";

const BasicPageBody = (
    props: Immutable<{ page: templates.BasicPageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    const components = buildContextualToolboxComponentsMap({
        pageSlug: props.page.slug,
    });
    return (
        <>
            {props.page.body.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{
                        className: `w-block-${block.type} block-${block.type}`,
                    }}
                    value={[block]}
                    components={components}
                />
            ))}
        </>
    );
};

export const Template = (
    props: Immutable<templates.BasicPageTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            showHeader={false}
            showFooter={false}
            wrapMain={false}
        >
            <BasicPageBody page={props.page} />
        </PageSkeleton>
    );
};
